var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.disdh)?_c('div',{staticClass:"animation"},[_c('img',{attrs:{"src":require("./assets/img/leftnav/logo.png"),"alt":""}}),_c('div',[_vm._v("布尔清单")]),_c('p',[_vm._v("版本：1.2.0")])]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }